import { render, staticRenderFns } from "./AppointmentForm.vue?vue&type=template&id=c799dc3a"
import script from "./AppointmentForm.vue?vue&type=script&lang=js"
export * from "./AppointmentForm.vue?vue&type=script&lang=js"
import style0 from "./AppointmentForm.vue?vue&type=style&index=0&id=c799dc3a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c799dc3a')) {
      api.createRecord('c799dc3a', component.options)
    } else {
      api.reload('c799dc3a', component.options)
    }
    module.hot.accept("./AppointmentForm.vue?vue&type=template&id=c799dc3a", function () {
      api.rerender('c799dc3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/offcanvas/AppointmentForm.vue"
export default component.exports